// extracted by mini-css-extract-plugin
module.exports = {"checkboxesContainer":"CreateEditClinics_checkboxesContainer__3mp_I","emails":"CreateEditClinics_emails__2YiDT","emailTagLabel":"CreateEditClinics_emailTagLabel__1APma"};